import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { formatErrorDesc } from '@/utilities/helpers';

export default function ErrorDescPopover({ errorDesc }: { errorDesc: unknown }) {
  const text = formatErrorDesc(errorDesc);
  if (text === '-') return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          title="View error description"
          aria-label="View error description"
          className="inline-flex h-5 w-5 items-center justify-center rounded-full text-rose-600 transition-colors hover:bg-rose-100 dark:text-rose-300 dark:hover:bg-rose-950/40"
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 max-w-[90vw] p-3">
        <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">Error Description</div>
        <div className="max-h-60 overflow-auto whitespace-pre-wrap break-words text-xs text-foreground">{text}</div>
      </PopoverContent>
    </Popover>
  );
}
